const routes = [
    {
        path: "/housing/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            isStaff:true
        }
    }
];

export default routes;
